module.exports = __webpack_public_path__ + "img/biaozhun.47a7fb88.png";